import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {UserService} from './user.service';

@Injectable()
export class LoggedInGuard implements CanActivate {
    constructor(private user: UserService,private router: Router) {}

    canActivate() {
        let loggato: boolean = this.user.isLoggedIn();
        if (!loggato) {
            this.router.navigate(['/login']);
        }
        return loggato;
    }
}


// WEBPACK FOOTER //
// ./src/app/service/logged.guard.ts